import { Helmet } from "react-helmet-async";

export default function Seo({ title, description, path }) {
  const base = "ترحال | Terhal Association Cooperative Tourism";

  return (
    <Helmet>
      <title>{title ? `${title} – ${base}` : base}</title>
      {description && <meta name="description" content={description} />}
      {path && <link rel="canonical" href={path} />}
    </Helmet>
  );
}
